import { initSentry } from "./lib/sentry";
import { createRoot } from "react-dom/client";

// chanli-ops 字體（bundled via @fontsource，無 runtime CDN 依賴）
import "@fontsource-variable/noto-sans-tc";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/700.css";

import App from "./App";
import "./index.css";

document.title = "訂單管理系統";

// Initialize Sentry before rendering (no-ops if DSN not configured)
initSentry();

createRoot(document.getElementById("root")!).render(<App />);
